import { smoothScroll } from '..'
import { UaCh } from '../foundation/UserAgent'

export class FooterAnimation {
  constructor() {
    // if (UaCh.isMobile) return
    this.footer = document.getElementById('js-footer')
    this.gallery = document.getElementById('js-gallery')
    this.footerContents = document.getElementById('js-footer_contents')
    this.copy = document.getElementById('js-footer_copy')
    const tick = (e) => {
      const { innerWidth, innerHeight } = window
      const gbcr = this.footerContents.getBoundingClientRect()
      const progress = (gbcr.top / innerHeight) * 2
      const percent = Math.min(1, Math.max(0.2, progress * 1.7))
      console.log(percent)
      if (percent < 1) {
        this.footerContents.classList.add('is-act')
      } else {
        this.footerContents.classList.remove('is-act')
      }
      this.gallery.style.setProperty('--footerOpacity', percent)
    }
    tick({ animatedScroll: 0 })
    smoothScroll.lenis.on('scroll', tick)
  }
}
